'use client';

import React from 'react';
import { useTranslation } from 'next-i18next';
import { ImageBj } from '@components/common';
import bestieImage from '@images/bestie/bestie.png';

/**
 * BestieWelcome
 *
 * Displays the animated Bestie AI avatar and a localized welcome message.
 * Used as the introductory visual when the user enters the Audio Interview flow.
 *
 * Features:
 *  - Animated avatar with decorative background pulse
 *  - Welcoming message box, localized via i18n
 */
export const BestieWelcome: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col items-center space-y-6">
      {/* Bestie Avatar */}
      <div className="relative flex items-center justify-center size-48">
        <ImageBj
          src={bestieImage}
          alt="Bestie AI"
          width={192}
          height={192}
          className="object-cover size-full"
        />
      </div>

      {/* Welcome Message */}
      <div className="max-w-sm px-6 py-4 shadow-lg rounded-2xl bg-surface-200">
        <p className="text-lg font-medium text-center text-ink">
          {t('audio-interview.bestie.message')}
        </p>
      </div>
    </div>
  );
};

